import {httpClient} from '../../common/api/HttpClient';

export const runApi = {
    createOrUpdateRun: (run) => httpClient.post(`runs/`, run)
};

export default runApi;
